export default __webpack_public_path__ + "static/media/p1.adc3ffc5.jpg";